import React, { useState } from 'react';
import axios from 'axios'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Alert
} from 'reactstrap'
import { useEffect } from 'react';
import { tokenConfig } from '../../utils/apiConfig';
import useDatePickerPortal from '../../utils/useDatePickerPortal';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const toDate = str => str ? new Date(str.substring(0, 10) + 'T00:00:00') : null
const fromDate = d => d ? [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-') : ''


const UpdateDetails = props => {

    const {
        modal, setModal, userDetails, setUserDetails
    } = props
    const { user } = userDetails
    const datePickerPortal = useDatePickerPortal()
    const [errorMessage, setErrorMessage] = useState('')
    const [dob, setDob] = useState(null)
    const [validId, setValidId] = useState(null)
    const [phoneNumber, setPhoneNumber] = useState(null)
    const [name, setName] = useState(null)

    useEffect(() => {
        if (user) {
            user.dob && setDob(user.dob)
            user.validId && setValidId(user.validId)
            user.phoneNumber && setPhoneNumber(user.phoneNumber)
            user.name && setName(user.name)
        }
    }, [user])

    // Function to open and close login modal
    const toggle = () => {
        setModal(!modal)
    }

    // Login Function
    const updateUser = async e => {
        e.preventDefault()

        try {
            const { data } = await axios.patch(`/api/auth`, { _id: user._id, dob, validId, phoneNumber, name }, tokenConfig())
            setUserDetails({ ...userDetails, user: data })
            toggle()
        } catch (err) {
            setErrorMessage(err.message)
        }
    }


    return (
        <div>
            <Modal
                isOpen={modal}
                toggle={toggle}
            >
                <ModalHeader
                    toggle={toggle}
                >
                    Profile Details
                </ModalHeader>
                <ModalBody>
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    <Form onSubmit={updateUser}>
                        <FormGroup>
                            <Label>Full Name</Label>
                            <Input
                                type="text"
                                defaultValue={name}
                                placeholder="Full Name as per ID"
                                onChange={e => setName(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Phone Number</Label>
                            <Input
                                type="text"
                                defaultValue={phoneNumber}
                                placeholder="eg. +60123456789"
                                onChange={e => setPhoneNumber(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>IC/Passport</Label>
                            <Input
                                type="text"
                                defaultValue={validId}
                                placeholder="Valid ID required"
                                onChange={e => setValidId(e.target.value)}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Date of Birth</Label>
                            <DatePicker
                                selected={toDate(dob)}
                                onChange={d => setDob(fromDate(d))}
                                dateFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={100}
                                className="form-control"
                                wrapperClassName="d-block"
                                placeholderText="Select date of birth"
                                {...datePickerPortal}
                                required
                            />
                        </FormGroup>
                        <Button
                            color="dark"
                            style={{ marginTop: "2rem" }}
                            block
                        >
                            Update Details
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default UpdateDetails
